import { PortfolioId } from '../../../../../../store/features/pageConfig';

const staticMenuItems = {
  // About KNect365 menu section
  aboutItems: {
    data: {
      title: 'About',
      titleTmt: 'About',
      button: 'home',
    },
    items: [
      {
        title: 'About us',
        text: 'Our live events and digital services give people extraordinary opportunities to enhance their professional knowledge and networks.',
        links: [
          {
            title: 'Learn about us >',
            href: 'https://informatech.com/',
          },
        ],
        backgroundImage: '/images/corporate-menu-images/about-us.jpg',
      },
      {
        title: 'Our Story',
        text: 'The name may be new, but we’ve been around for a while.',
        links: [
          {
            title: 'Read our story >',
            href: '/about/our-story',
          },
        ],
        backgroundImage: '/images/corporate-menu-images/our-story.jpg',
      },
      {
        title: 'Join our team',
        text: 'We’re always looking for exceptional people who want to make a difference.',
        links: [
          {
            title: 'Careers >',
            href: '/about/careers',
          },
          {
            title: 'View our jobs >',
            href: '/about/careers/vacancies',
          },
        ],
        backgroundImage: '/images/corporate-menu-images/careers.jpg',
      },
      {
        title: 'Contact us',
        text: 'We are more than 1,000 people, working in more than 60 markets.',
        links: [
          {
            title: 'Office locations >',
            href: '/about/contact-us',
          },
          {
            title: 'Make an enquiry >',
            href: '/about/contact-us#contact_form',
          },
        ],
        backgroundImage: '/images/corporate-menu-images/contact-us.jpg',
      },
    ],
  },

  // Learning menu section
  learningItems: {
    [PortfolioId.TMT_KNECT365]: [
      {
        title: 'Telecoms &amp; Tech Academy',
        descriptions: 'Telecoms Business, 5G, Connected Innovation',
        path: 'https://telecomstechacademy.com',
        button: 'telecomstechacademy.com',
      },
    ],
  },
};

export default staticMenuItems;
